import $apiJSON from 'http/apiJSON'
import { currentAuthSession, ensureAuthSession } from 'http/authSession'

let pending = null

// Record the actor before clearing credentials; a failed audit never traps a user.
export async function recordLogout() {
  if (!localStorage.getItem('token')) return true
  const session = ensureAuthSession()
  if (!pending || pending.session !== session) {
    const operation = $apiJSON.post('/account/login/logout/', {}, { timeout: 2000 }).catch(() => undefined)
    const own = { session, operation }
    pending = own
    operation.finally(() => { if (pending === own) pending = null })
  }
  const operation = pending.operation
  await operation
  // A late logout from the previous login cannot clear a newer identity.
  return currentAuthSession() === session
}
